/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { CSSProperties, useState } from 'react';
import { ControlsCellWrapper } from './ControlsCellWrapper';
import { generateGridTemplate } from '../../utils';
import { Add } from '@td-client-frontend/icons';
import { ConfirmButtonArray } from './ConfirmButtonArray';
import clsx from 'clsx';

function getRenamedFieldsForNestedArrayItems({ fields, name }) {
  const [arrayFieldName] = name.split('.');
  return fields.map((childField) => {
    return { ...childField, name: `${arrayFieldName}.${childField.name}` };
  });
}

export function ItemArray({
  fields,
  isError,
  itemDefault,
  fieldIndex,
  name,
  entityName,
  remove,
  push,
  isLastElement,
  isOnlyElement
}) {
  const editedFields = fields.map((field) => ({
    ...field,
    name: `${name}.${field.name}`
  }));
  const [isConfirmToDeleteShown, setConfirmToDeleteShown] = useState(false);
  const style: CSSProperties = {
    gridTemplateColumns: generateGridTemplate(fields)
  };

  function removeHandler() {
    remove(fieldIndex);
  }

  function afterShow() {
    setConfirmToDeleteShown(true);
  }
  function afterHide() {
    setConfirmToDeleteShown(false);
  }

  function getChildren({ name: fieldName, component }, index: number) {
    if (editedFields.length === index + 1 && component !== 'row') {
      return (
        <div className='self-center flex-initial w-8 h-8 ml-4'>
          {(fieldIndex > 0 || !isOnlyElement) && (
            <ConfirmButtonArray
              id={`${fieldName}.${index}_remove`}
              entityName={entityName}
              onClick={removeHandler}
              afterShow={afterShow}
              afterHide={afterHide}
            >
              <Add transform='rotate(45)' />
            </ConfirmButtonArray>
          )}
        </div>
      );
    }
  }

  return (
    <div className='col-span-12'>
      <div className={clsx('grid gap-8 pl-3 -ml-3', isConfirmToDeleteShown && 'bg-cinderella')} style={style}>
        {editedFields.map((field, index) => {
          if (field.component === 'label' && fieldIndex > 0) {
            field.label = '';
          }
          const cellFields =
            field.component === 'row' && field.fields
              ? { ...field, fields: getRenamedFieldsForNestedArrayItems(field) }
              : field;

          return (
            <ControlsCellWrapper field={cellFields} key={`${field.name}-${index}-wrapper`}>
              {getChildren(field, index)}
            </ControlsCellWrapper>
          );
        })}
      </div>
    </div>
  );
}
